module.exports = __webpack_public_path__ + "static/img/zncrm-details.6ab6d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zncrm-details.png
// module id = EPCJ
// module chunks = 0